export var RadioBullet = _ref => {
  var {
    checkboxColor,
    checkboxCheckmarkColor
  } = _ref;
  return _ref2 => {
    var {
      checked,
      error,
      warning,
      disabled
    } = _ref2;
    return error || warning || disabled || !checked || checkboxColor == null || checkboxCheckmarkColor == null ? {} : {
      borderStyle: {
        borderColor: checkboxColor.toString()
      },
      solidColorStyle: {
        backgroundColor: checkboxColor.toString()
      },
      innerCircleStyle: {
        backgroundColor: checkboxCheckmarkColor.toString()
      }
    };
  };
};
//# sourceMappingURL=RadioBullet.js.map